// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword
} from "firebase/auth";
import { getDatabase, ref, set } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAY4zuG6ydmrEOUDsF7T95yh-X381JGWcU",
  authDomain: "expense-24eed.firebaseapp.com",
  projectId: "expense-24eed",
  storageBucket: "expense-24eed.appspot.com",
  messagingSenderId: "1020276897604",
  appId: "1:1020276897604:web:f31f6be86280a0f9e9c911",
  measurementId: "G-LZ552CYKES",
  databaseURL: "https://expense-24eed-default-rtdb.firebaseio.com"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const database = getDatabase(app);

export {
  auth,
  provider,
  signInWithPopup,
  createUserWithEmailAndPassword, // ✅ Add this
  signInWithEmailAndPassword,     // ✅ Add this
  database,
  ref,
  set
};
